import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import FiltersTable from "../../../components/FiltersTable";
import { formatISDDate } from "../../common";
import { commonStrings } from "../../../components/StringBundle";

const formatDate = (datestr) => {
  let dateVal = new Date(datestr);
  return datestr
    ? dateVal.getDate() +
        "-" +
        (dateVal.getMonth() + 1) +
        "-" +
        dateVal.getFullYear()
    : "";
};

function createData(
  field,
  oldValue,
  newValue,
  createdBy,
  createdAt
) {
  return { field, oldValue, newValue, createdBy, createdAt };
}

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 24,
    textTransform:'capitalize'
  },
  container: {
    maxHeight: 440,
  },
});

const AuditLog = (props) => {
  const classes = useStyles();
  const [allData, setAllData] = useState([]);
  const rows = [];

  const antColumns = [
    {
      title: commonStrings.field,
      dataIndex: 'field',
      key: 'field',
      width: '15%'
    },
    {
      title: commonStrings.oldValue,
      dataIndex: 'oldValue',
      key: 'oldValue',
      width: '15%',
    },
    {
      title: commonStrings.newValue,
      dataIndex: 'newValue',
      key: 'newValue',
      width: '15%'
    },
    {
      title: commonStrings.modifiedBy,
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: '15%',
    },
    {
      title: commonStrings.modifiedDate,
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '15%',
    }
  ];

  React.useEffect(() => {
    console.log("Props Data", props.data);
    props.data &&
     // eslint-disable-next-line
      props.data.map((v) => {
        rows.push(
          createData(
            v.field,
            v.oldValue,
            v.newValue,
            v.createdBy,
            formatISDDate(v.createdAt)
          )
        );
      });
       setAllData(rows)
  }, [props.data]);
  function getalltableData(data) {}
  return (
    <Paper className={classes.root}>
      <FiltersTable  alltableData={getalltableData} columns={antColumns} tableData={allData} />
    </Paper>
  );
};

export default AuditLog;
